const initialState = {
    authToken: null,
};

const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_AUTH_TOKEN':
            return {
                ...state,
                authToken: action.payload,
            };
        default:
            return state;
    }
};

export default rootReducer;